import { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { LoadingContext } from "../../../../../contexts/Loading/LoadingContext";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import { api, errorTreatment } from "../../../../../services/api";
import { ChartBar } from "./chart";
import "../../style.css";

export interface Documents {
  data: {
      documents: {[propriedade: string]: string}[];
  };
}

export const ChartAdoptionRateCourier = () => {
  const { changeVisibility } = useContext(LoadingContext);
  const { reloadComponent } = useContext(DashboardContext);
  const { shortToken, id, mode } = useParams();

  let routeDocuments: string;
  const [documents, setDocuments] = useState<Documents["data"]>({documents: []});
  const [completeRequisition, setCompleteRequisition] = useState(false);

  if (shortToken) {
    routeDocuments = `/adoptionRate?mode=couriers&short_token=${shortToken}&screen_id=${id}`;
  } else {
    routeDocuments = `/adoptionRate?mode=courier&screen_id=${id}`;
  }

  useEffect(() => {
    changeVisibility(true);
    const fetchData = async () => {
      try {
        await requisition();
      } finally {
        changeVisibility(false);
        setCompleteRequisition(true);
      }
    };
    fetchData();
    if (mode === "view") {
      const intervalId = setInterval(() => {
        requisition();
      }, 60000);
      return () => clearInterval(intervalId);
    }
  }, []);

  async function requisition() {
    return await api
      .get(routeDocuments)
      .then((documents: Documents) => {
        setDocuments(documents.data);
      })
      .catch((error) => {
        errorTreatment(error);
      });
  }

  return completeRequisition && !reloadComponent ? (
    <div id="chart-adoption-rate-courier" className="h100">
      <ChartBar data={documents} />
    </div>
  ) : (
    <></>
  );
};
